import { Component, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'rcs-web';
  public scroll;
  public stick = false;
  constructor(private renderer: Renderer2) {}
  ngOnInit() {
    this.renderer.listen(window, 'scroll', ($event) => {
       this.scroll = (window.scrollY);
      if(this.scroll == 550){
        this.stick = true;
      }
    })
  }
  onActivate(event) {
    window.scroll(0,0);
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
}
}
